<template>
  <div :class="$style['layout-com']">
    <div :class="$style['header-content']">
      <div :class="$style['page-info']" v-if="showCompany">
        <img :class="$style['company-logo']" :src="fullLogo" @click="tapIconHandle(iconConfigCom)" />
        <span :class="$style['client-name']">实证分析平台</span>
      </div>
      <div :class="$style['page-info']" v-else>
        <slot name="icon-content"></slot>
        <div
          :class="$style['icon-tool']"
          v-if="iconConfigCom.show && !$slots['icon-content']"
          @click="tapIconHandle(iconConfigCom)"
        >
          <img
            v-if="iconConfigCom.isImg"
            :src="iconConfigCom.imgUrl"
            :class="$style['icon-img']"
            :style="iconConfigCom.style || {}"
          />
          <div v-else-if="iconConfigCom.isBack" :class="$style['icon-tool-back-btn']">
            <i class="el-icon-arrow-left"></i>
            <span>{{ iconConfigCom.backText || '返回' }}</span>
          </div>
          <i v-else :class="[iconConfigCom.iconName, $style['icon']]" :style="iconConfigCom.style || {}"></i>
        </div>
        <div
          :class="[
            $style['title'],
            showSplitLine ? $style['split-line'] : '',
            $slots['custom-title'] ? '' : 'single-ellipsis'
          ]"
          v-if="title || $slots['custom-title']"
        >
          <slot v-if="$slots['custom-title']" name="custom-title"></slot>
          <span v-else>{{ title }}</span>
        </div>
        <div v-if="$slots['tip-msg']" :style="{ marginLeft: '12px' }">
          <slot name="tip-msg"></slot>
        </div>
      </div>
      <div
        :style="tabsStyle"
        :class="[$style['tabs-content'], showNoviceTip ? $style['show-novice'] : '']"
        v-if="haveTabs"
      >
        <div
          v-for="tabItem in tabs"
          :key="tabItem.action"
          :class="[
            $style['tab-item'],
            tabActive === tabItem.action ? $style['is-active'] : '',
            (currentTipTab && currentTipTab.action) === tabItem.action ? $style['is-tip-item'] : ''
          ]"
          @click="checkoutTabHandle(tabItem)"
        >
          <span class="single-ellipsis" :class="$style['tab-text']">{{ tabItem.title }}</span>
          <template v-if="(currentTipTab && currentTipTab.action) === tabItem.action">
            <img :class="$style['novice-tip-img']" :src="noviceTip" />
            <div :class="$style['novice-tip-content']">
              <span>{{ currentTipTab.tipMsg }}</span>
              <div :class="$style['novice-tip-btn']" @click="currentTipTab.show = false">
                <span v-if="!currentTipTab.isEnd">下一步</span>
                <span v-else>我知道了</span>
              </div>
            </div>
          </template>
        </div>
        <div :class="$style['novice-mask']" v-if="showNoviceTip"></div>
      </div>

      <div :style="{ flex: 1, marginRight: '10px', height: '100%' }" v-if="$slots['custom-btn']">
        <slot name="custom-btn"></slot>
      </div>

      <div :class="$style['user-info-container']">
        <a
          :class="$style['custom-service-btn']"
          :style="{ marginRight: '10px' }"
          :href="helpUrl"
          target="blank"
          v-if="false"
        >
          <i class="iconfont iconbangzhu"></i>
          <span>帮助中心</span>
        </a>
        <div
          :class="$style['custom-service-btn']"
          :style="{ marginRight: '10px' }"
          @click="menuHandle('customService')"
        >
          <i class="iconfont iconlianxikefu1"></i>
          <span>客服</span>
        </div>
        <el-popover placement="bottom-end" title="" width="200" trigger="hover" v-if="!!helpMode">
          <div slot="reference" :class="$style['custom-service-btn']" :style="{ marginRight: '10px' }">
            <i class="iconfont iconbangzhu"></i>
            <span>帮助视频</span>
          </div>
          <div :style="{ padding: '10px' }">
            <helpPane :mode="helpMode" />
          </div>
        </el-popover>

        <el-dropdown @command="commandKey => menuHandle(commandKey)">
          <div :class="$style['user-info']">
            <span
              class="icon-big"
              :style="{ margin: '0 10px 0 0', borderRadius: '20px', width: '20px', height: '20px', overflow: 'hidden' }"
            >
              <img v-if="userInfo.headimgurl" :src="userInfo.headimgurl" />
            </span>
            <span class="el-dropdown-link"> {{ userInfo.name }}<i class="el-icon-arrow-down el-icon--right"></i> </span>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="/product">
              <div :style="{ lineHeight: '40px' }">
                <span class="icon-middle" :style="{ margin: '0 10px 4px 0' }"><img :src="vipSign"/></span>
                <span>产品服务与付费</span>
              </div>
            </el-dropdown-item>
            <el-dropdown-item command="/center">
              <div :style="{ lineHeight: '40px' }">
                <span class="icon-middle" :style="{ margin: '0 10px 4px 0' }"
                  ><i :style="{ marginLeft: '1px' }" class="iconfont icongerenzhongxin"></i></span
                >个人中心
              </div>
            </el-dropdown-item>
            <el-dropdown-item command="/logout">
              <div :style="{ lineHeight: '40px' }">
                <span class="icon-middle" :style="{ margin: '0 10px 4px 0' }"
                  ><i :style="{ marginLeft: '1px' }" class="iconfont icontuichudenglu"></i></span
                >退出登录
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div
      :class="$style['vip-tips']"
      :style="contentStyle"
      v-if="vipTipPaneShow && freeOrderInfo.count"
      @click="payHandle"
    >
      <div :class="$style['close-btn']">
        <i class="iconfont iconcha" :class="$style['close-icon']" @click.stop="vipTipPaneShow = false"></i>
      </div>
      <div :class="$style['vip-tips-body']">
        <div :class="$style['tip']" class="word-normal">
          <span
            >新用户享受{{ freeOrderInfo.count }}个免费的试用课题，课题数据集为{{
              freeOrderInfo.dataSize
            }}个案例。如需进行深度研究分析，请购买专业版课题。</span
          >
        </div>
        <div :class="$style['upgrade']" class="word-smaller">查看产品服务与价格</div>
      </div>
    </div>
    <slot name="custom-header"></slot>
    <div :class="$style['content']" :style="contentStyle">
      <slot></slot>
    </div>

    <custom-service :show.sync="showWechat" />

    <upgrade-modal v-if="upgradeModalShow" :show.sync="upgradeModalShow" />
  </div>
</template>

<script>
import noviceTip from '@/assets/img/noviceTip.png';
import vipSign from '@/assets/img/权益-小.png';
import fullLogo from '@/assets/img/fullLogo.png';

import customService from '@/components/customService';
import upgradeModal from '@/components/upgradeModal';
import { mapGetters } from 'vuex';
import helpPane from '@/components/helpPane';

export default {
  data() {
    return {
      fullLogo,
      tabTipArr: [],
      noviceTip,
      vipSign,
      showWechat: false,
      vipTipPaneShow: false,
      upgradeModalShow: false
    };
  },
  components: { customService, upgradeModal, helpPane },
  props: {
    title: {
      type: String,
      default: ''
    },
    contentMaxWidth: {
      type: String,
      default: ''
    },
    iconConfig: {
      type: Object,
      default: () => ({})
    },
    tabs: {
      type: Array,
      default: () => [],
      validator: tabArr => {
        const requiredKey = ['title', 'action'];
        return tabArr.every(tabItem => {
          return requiredKey.every(key => tabItem[key]);
        });
      }
    },
    tabActive: {
      type: String,
      default: ''
    },
    tabNoviceArr: {
      type: Array,
      default: () => []
    },
    vipTipShow: {
      type: Boolean,
      default: false
    },
    showCompany: {
      type: Boolean,
      default: false
    },
    helpMode: {
      type: String,
      default: ''
    }
  },
  watch: {
    tabNoviceArr: {
      handler(val) {
        this.startTabNovice(val);
      }
    },
    vipTipShow: {
      handler(val) {
        if (val) {
          this.vipTipPaneShow = true;
        } else {
          this.vipTipPaneShow = false;
        }
      },
      immediate: true
    }
  },
  computed: {
    helpUrl() {
      return `${window.location.origin}/home.html#/help`;
    },
    contentStyle() {
      const style = {};
      if (this.contentMaxWidth.length > 0) {
        style['padding'] = `0 calc((100% - ${this.contentMaxWidth}) / 2)`;
      }
      return style;
    },
    iconConfigCom() {
      const iconDefaultConfig = {
        show: true,
        url: '/',
        iconName: 'iconfont iconshouye',
        isImg: false
      };
      const config = { ...this.iconConfig };

      Object.keys(iconDefaultConfig).forEach(key => {
        if (!Object.prototype.hasOwnProperty.bind(config)(key)) {
          config[key] = iconDefaultConfig[key];
        }
      });

      return config;
    },
    showSplitLine() {
      return this.iconConfigCom.show || this.$slots['icon-content'];
    },
    haveTabs() {
      return this.tabs.length > 0;
    },
    tabsStyle() {
      const tabLength = this.tabs.length;
      if (tabLength < 1) {
        return {};
      }
      const width = tabLength * 100 + (tabLength - 1) * 10;
      return { marginLeft: `-${Math.ceil(width / 2)}px` };
    },
    userInfo() {
      return this.$store.getters.userInfo;
    },
    showNoviceTip() {
      return this.tabTipArr.some(item => item.show);
    },
    currentTipTab() {
      // 正在显示的提示
      return this.tabTipArr.find(item => item.show);
    },
    ...mapGetters(['orders']),
    freeOrderInfo() {
      let count = 0;
      let dataSize = 500;

      this.orders.forEach(orderItem => {
        const productArr = orderItem.product.productList || [];
        productArr.forEach(productItem => {
          if (!productItem.chargeStr) {
            return;
          }
          const charge = JSON.parse(productItem.chargeStr);
          if (!charge.versionLevel) {
            count += charge.courseNum || 1;
            dataSize = charge.courseDataSetMaxNum || 500;
          }
        });
      });

      return { count, dataSize };
    }
  },
  mounted() {
    // if (this.$route.name === 'home') {
    //   const upgradeVersion = localStorage.getItem('upgradeVersion');
    //   const version = process.env.VUE_APP_VERSION || '';
    //   console.log(version);
    //   if (upgradeVersion !== version) {
    //     this.upgradeModalShow = true;
    //     localStorage.setItem('upgradeVersion', version);
    //   }
    // }
  },
  methods: {
    checkoutTabHandle(tabItem) {
      if (this.currentTipTab) {
        return;
      }
      if (tabItem.action !== this.tabActive) {
        this.$emit('update:tabActive', tabItem.action);
        this.$emit('changeTab', tabItem);
      }
    },
    tapIconHandle(config) {
      if (config.isOfficial) {
        window.location.href = window.location.origin;
      } else if (config.isBack) {
        if (this.iconConfig.url) {
          const unWatcher = this.$router.beforeEach((to, from, next) => {
            unWatcher();
            if (to.path === config.url) {
              next();
            } else {
              next(config.url);
            }
          });
        }
        // 兼容点击进入课题无法返回课题首页的情况
        const curRoutePath = this.$route.fullPath;
        this.$router.back();
        setTimeout(() => {
          if (this.$route.fullPath === curRoutePath) {
            this.$router.replace('/');
          }
        }, 100);
      } else if (config.url) {
        this.$router.push(config.url);
      }
    },
    startTabNovice(tabNoviceArr) {
      const tabActionArr = this.tabs.map(tabItem => tabItem.action);
      const tipArr = tabNoviceArr.filter(noviceItem => tabActionArr.includes(noviceItem.action));
      if (tipArr.length > 0) {
        const tabTipArr = tipArr.map(item => {
          return { ...item, show: true };
        });
        tabTipArr[tabTipArr.length - 1].isEnd = true;
        this.tabTipArr = tabTipArr;
      }
    },
    async menuHandle(commandKey) {
      if (commandKey === 'customService') {
        this.showWechat = true;
      } else if (commandKey === '/product') {
        const location = window.location;
        window.open(`${location.origin}${location.pathname}#/product`, '_blank');
      } else if (commandKey == '/logout') {
        await this.$store.dispatch('logout', { replaceToLogin: true, sendEvent: true });
      } else {
        this.$router.push({
          path: commandKey
        });
      }
    },
    payHandle() {
      this.$router.push({
        path: '/product'
      });
    }
  }
};
</script>

<style lang="scss" module>
.layout-com {
  box-sizing: border-box;
  width: 100%;
  min-width: 1200px;
  height: 100vh;
  overflow: hidden;
  background-color: #f9fbff;
  display: flex;
  flex-direction: column;

  .header-content {
    position: relative;
    width: 100%;
    height: $headerHeight;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0px 3px 4px 0px rgba(122, 133, 150, 0.1);
    border-bottom: 1px solid #ebeef5;
    background-color: #fff;

    .tabs-content {
      position: absolute;
      top: 0;
      left: 50%;
      display: flex;
      align-items: center;
      height: 50px;
      background-color: #fff;
      z-index: 10;

      &.show-novice {
        z-index: 10000;

        .novice-mask {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.7);
          z-index: 1;
        }
      }

      .tab-item {
        box-sizing: border-box;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        width: 100px;
        height: 100%;
        text-align: center;
        font-size: 14px;
        color: rgba(#3d465a, 0.7);
        margin-left: 10px;
        padding: 0 10px;
        cursor: pointer;
        background-color: #fff;

        .tab-text {
          max-width: 100%;
        }

        .novice-tip-img {
          position: absolute;
          left: -117px;
          top: 10px;
          width: 117px;
          height: 114px;
          z-index: 2;
        }

        .novice-tip-content {
          position: absolute;
          top: 120px;
          left: 50%;
          transform: translateX(-50%);
          text-align: left;
          width: 414px;
          font-size: 14px;
          line-height: 22px;
          color: #fff;
          padding-bottom: 56px;

          .novice-tip-btn {
            position: absolute;
            right: 0;
            bottom: 0;
            text-align: center;
            width: 86px;
            height: 36px;
            line-height: 36px;
            border: 1px solid #fff;
            border-radius: 4px;
            cursor: pointer;
          }
        }

        &.is-tip-item {
          z-index: 2;
        }

        &.is-active {
          background-color: #ecf7ff;
          color: #0c93f2;

          &::after {
            content: ' ';
            position: absolute;
            top: 0px;
            left: 50%;
            transform: translateX(-50%);
            width: 100%;
            height: 2px;
            background-color: #3494d8;
          }
        }

        &:first-child {
          margin-left: 0;
        }
      }
    }

    .page-info {
      display: flex;
      align-items: center;

      .company-logo {
        width: 144px;
        height: 24px;
        margin-left: 20px;
        cursor: pointer;
      }
      .client-name {
        color: #172237;
        font-size: 16px;
        line-height: 24px;
        font-weight: 700;
        margin-left: 10px;
      }

      .title {
        box-sizing: border-box;
        position: relative;
        width: 540px;
        font-size: 16px;
        color: #3d465a;
        padding: 2px 12px;

        &.split-line {
          /* &::before {
            content: ' ';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            height: 100%;
            width: 1px;
            background-color: #d9dde4;
          } */
        }
      }

      .icon-tool {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 12px 0 20px;
        cursor: pointer;

        .icon-tool-back-btn {
          box-sizing: border-box;
          color: #172237;
          font-size: 14px;
          height: 32px;
          line-height: 32px;
          padding: 0 16px 0 10px;
          border-top-right-radius: 16px;
          border-bottom-right-radius: 16px;
          background-color: #f3f5f8;
          cursor: pointer;
          margin-left: -20px;

          &:hover {
            background: #f3f9ff;
            color: #409eff;
          }

          & > span {
            margin-left: 6px;
          }
        }

        .icon {
          color: #0c93f2;
          font-size: 18px;
        }

        .icon-img {
          width: 30px;
          height: 30px;
          object-fit: cover;
        }
      }
    }

    .user-info-container {
      display: flex;
      align-items: center;
      color: rgba(#3d465a, 0.7);

      .user-info {
        text-align: right;
        padding: 10px;
        cursor: pointer;
      }

      .custom-service-btn {
        text-decoration: none;
        font-size: 14px;
        cursor: pointer;
        padding: 10px 5px;
        color: #409eff;

        & > i {
          font-size: 16px;
          margin-right: 4px;
        }
      }
    }
  }

  .content {
    box-sizing: border-box;
    width: 100%;
    height: 0;
    flex: 1;
    overflow: auto;

    &::-webkit-scrollbar {
      display: none;
    }
  }
}
.vip-tips {
  box-sizing: border-box;
  position: relative;
  width: 100%;
  line-height: 40px;
  background: linear-gradient(270deg, rgba(253, 209, 108, 0.2) 0%, rgba(253, 209, 108, 0.2) 100%);
  cursor: pointer;

  .vip-tips-body {
    box-sizing: border-box;
    padding: 0 20px;
  }

  .close-btn {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);

    .close-icon {
      font-size: 14px;
      color: rgba(#3d465a, 0.5);
      padding: 5px;
      cursor: pointer;
    }
  }
  &-body {
    max-width: 1440px;
    width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
  }
  .tip {
    color: rgba(#fb7519, 0.8);
  }
  .upgrade {
    line-height: 24px;
    height: 24px;
    background: linear-gradient(270deg, rgba(#ff923b, 0.8) 0%, rgba(#fdd16c, 0.8) 100%);
    border-radius: 12px;
    margin-top: 6px;
    color: rgba(#a14a0e, 0.8);
    width: 130px;
    text-align: center;
  }
}
</style>
